import TransferenciaEntradaModal from "./TransferenciaEntradaModal";
export default TransferenciaEntradaModal;